import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import Box from "./Box";
import Heading from "./Heading";
import Container from "./UI/Container";
import FooterWrapper, {
  List,
  ListItem,
  BottomRow,
  BottomRowMobile,
} from "./footerStyle";
import styles from './Footer.module.css'

import NavBarLogo from "@assets/home/navbar_logo_adjusted.svg";
import About_Footer_Data from './footerData';
import InstagramBlack from "assets/home/InstagramBlack";
import LinkedInBlack from "assets/home/LinkedInBlack";

const Footer = ({
  about,
  row,
  col,
  colOne,
  colTwo,
  titleStyle,
  logoStyle,
  textStyle,
}) => {
  return (
    <FooterWrapper>
      <Container className="footer_container">
        <Box className="row" {...row}>
          <Box {...colOne}>
            <div
              style={{
                transform: "scale(.8)",
                position: "relative",
                left: "-24px",
              }}
              className={styles.logo}
            >
              <NavBarLogo />
            </div>
            {/* <Text content="hello@lifeshack.com" {...textStyle} /> */}
          </Box>
          {/* End of footer logo column */}
          <Box {...colTwo}>
            {About_Footer_Data.map((widget, index) => (
              <Box className="col" {...col} key={`footer-widget-${index}`}>
                <Heading content={widget.title} {...titleStyle} />
                <List>
                  {widget.menuItems.map((item, index) => (
                    <ListItem key={`footer-list-item-${index}`}>
                      <Link href={item.url}>
                        <a className="ListItem">{item.text}</a>
                      </Link>
                    </ListItem>
                  ))}
                </List>
              </Box>
            ))}
          </Box>
          {/* End of footer List column */}
        </Box>
        <BottomRow>
          <div style={{ fontSize: "17px" }}>
            Copyright © 2024 LifeShack Inc - All Rights Reserved<span style={{ marginLeft: "20px", height: "8px" }}>✉️ <span style={{ paddingRight: "5px" }} />hello@lifeshack.com</span>
          </div>
          <div style={{ display: "flex" }}>
            <a
              href="https://www.instagram.com/lifeshackofficial"
              target="_blank"
              rel="noreferrer"
            >
              <InstagramBlack />
            </a>

            <a
              style={{ marginLeft: "15px" }}
              href="https://www.linkedin.com/company/lifeshack-jobs"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedInBlack />
            </a>
          </div>
        </BottomRow>
        <BottomRowMobile>
          <div>Copyright © 2024 LifeShack Inc</div>
          <div>All Rights Reserved</div>
          <div style={{ marginTop: "24px", marginBottom: "3px" }}>✉️<span style={{ paddingRight: "4px" }} /> hello@lifeshack.com</div>
          <div style={{ display: "flex", marginTop: "20px" }}>
            <a
              href="https://www.instagram.com/lifeshackofficial"
              target="_blank"
              rel="noreferrer"
            >
              <InstagramBlack />
            </a>

            <a
              style={{ marginLeft: "15px" }}
              href="https://www.linkedin.com/company/lifeshack-jobs"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedInBlack />
            </a>
          </div>
        </BottomRowMobile>
      </Container>
    </FooterWrapper>
  );
};

// Footer style props
Footer.propTypes = {
  row: PropTypes.object,
  col: PropTypes.object,
  colOne: PropTypes.object,
  colTwo: PropTypes.object,
  titleStyle: PropTypes.object,
  textStyle: PropTypes.object,
  logoStyle: PropTypes.object,
};

// Footer default style
Footer.defaultProps = {
  // Footer row default style
  row: {
    flexBox: true,
    flexWrap: "wrap",
    ml: "-15px",
    mr: "-15px",
  },
  // Footer col one style
  colOne: {
    width: [1, "35%", "35%", "23%"],
    mt: [0, "13px"],
    mb: ["30px", 0],
    pl: ["15px", 0],
    pr: ["15px", "15px", 0],
  },
  // Footer col two style
  colTwo: {
    width: ["100%", "65%", "65%", "77%"],
    flexBox: true,
    flexWrap: "wrap",
  },
  // Footer col default style
  col: {
    width: ["100%", "50%", "50%", "25%"],
    pl: "15px",
    pr: "15px",
    mb: "30px",
  },
  // widget title default style
  titleStyle: {
    color: "#343d48",
    fontSize: "16px",
    fontWeight: "700",
    mb: "30px",
  },
  // Default logo size
  logoStyle: {
    width: "100px",
    mb: "15px",
  },
  // widget text default style
  textStyle: {
    color: "#0f2137",
    fontSize: "16px",
    mb: "10px",
  },
};

export default Footer;
